import React, { createContext, useEffect, useState } from "react";

export enum langCode {
  en = "en",
  fr = "fr",
}

interface langContextType {
  lang_id: string;
  lang: string;
  lang_code: "en" | "fr";
  setLang: (lang: langsType) => void;
}

const inititalLangContext: langContextType = {
  lang_id: "",
  lang: "",
  lang_code: langCode.fr,
  setLang: () => {},
};

export const LangContext = createContext<langContextType>(inititalLangContext);

export const LanguageProvider = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  const [lang, setLang] = useState<langsType>({
    id: "",
    lang: "",
    lang_code: langCode.fr,
    lang_type: "",
  });

  const changeLang = (lang: langsType) => {
    setLang(lang);
  };
  useEffect(() => {
    const localLang = localStorage.getItem("lang");
    if (localLang) {
      setLang({
        ...lang,
        lang_code: JSON.parse(localLang).lang_code,
      });
    }
  }, []);

  return (
    <LangContext.Provider
      value={{
        lang_id: lang.id,
        lang: lang.lang,
        setLang: changeLang,
        lang_code: lang.lang_code,
      }}
    >
      {children}
    </LangContext.Provider>
  );
};

export default LangContext;
